import { NumberParser } from '@internetarchive/field-parsers';
import { MetadataField } from '../metadata-field';
export class NumberField extends MetadataField {
    constructor(rawValue) {
        super(NumberParser.shared, rawValue);
    }
}
//# sourceMappingURL=number.js.map